/**
 * User enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
export const userColorLabels = {
    blue: 'Blue',
    green: 'Green',
    red: 'Red',
    yellow: 'Yellow',
    purple: 'Purple',
    orange: 'Orange',
};
export const userColorValues = Object.keys(userColorLabels);
//# sourceMappingURL=users.js.map